export default class ImageType {
  constructor(rawData = {}) {
    this.id = rawData.id;
    this.name = rawData.name;
  }
}
